import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal';

import './style.css';

import { CLIENT_URL } from '../../config.local';

const VideoPlayer = ({ isYoutube, src, active, togglePlayer, autoPlay }) => {
  return (
    <Modal active={active}>
      <div className="video-player-container">
        <button onClick={togglePlayer} className="video-player-close-box">
          <i className="fas fa-times"></i>
        </button>
        {isYoutube ? (
          <iframe
            title="youtube video"
            className="video-player"
            src={src}
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        ) : (
          <video
            controls
            autoPlay={autoPlay}
            className="video-player"
            src={`${CLIENT_URL}${src}`}
          />
        )}
      </div>
    </Modal>
  );
};
VideoPlayer.propTypes = {
  autoPlay: PropTypes.bool,
  isYoutube: PropTypes.bool,
  src: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  togglePlayer: PropTypes.func.isRequired
};

VideoPlayer.defaultProps = {
  autoPlay: true,
  isYoutube: false
};

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/index.js